// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-SizeVarChange-SizeVarChange-module__formContent--qRTYF {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-SizeVarChange-SizeVarChange-module__formContent--qRTYF > * {
  padding: 16px 24px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/cellComponents/SizeVarChange/SizeVarChange.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;AAAE;EACE,kBAAA;AAEJ","sourcesContent":[".formContent {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  & > * {\n    padding: 16px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContent": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-SizeVarChange-SizeVarChange-module__formContent--qRTYF`
};
export default ___CSS_LOADER_EXPORT___;
